module.exports = require("@git-stack/server-core");